const crypto = require('crypto');

const algorithm = 'aes-256-ctr';
// const secretKey = 'vOVH6sdmpNWjRRIqCc7rdxs01lwHzfr3';
//const iv = crypto.randomBytes(16);
const secretKey = '=zilimwabagabo====zilimwabagabo=';
const iv = '1234567890123456';
//const iv = '504e8b40b5019f83c87f2cd9663a42d2';

const encrypt = (text) => {

    const cipher = crypto.createCipheriv(algorithm, secretKey, iv); 
    const encrypted = Buffer.concat([cipher.update(text), cipher.final()]);

    // return {
    //     iv: iv.toString('hex'),
    //     content: encrypted.toString('hex')
    // };
    return encrypted.toString('hex')
};

// const mra=()=>{
//     // const terminalActivationCode = "MJWM-AEYA-1MJD-9U66";
//     // const secretKey = "f4a7723cf13ca00496378ad391d41011425780f";
//     const terminalActivationCode = "27RJ-G14J-6QCQ-WT9D";
//     const secretKey = "02477e3a5107a904c4e7819690e35001d75f16c";
//     const hash = crypto.createHmac('sha512',secretKey)
//     .update(terminalActivationCode).digest('base64')
//     return hash
// }

const mra=()=>{ 
    const terminalActivationCode = "ee4a0748-9634-4ab9-851d-7604922561b7";
    const secretKey = "742a75f19134a1048497bcb197b1e012535a76e";
    const hash = crypto.createHmac('sha512',secretKey)
    .update(terminalActivationCode).digest('base64')
    return hash
}
const BASE64_CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";

/**
 * Converts a Base10 number (or string) to the specific Base64 format required by MRA.
 */
const base10ToBase64=(number)=> {
  let n = BigInt(number);
  if (n === 0n) return "A";
  
  let result = "";
  while (n > 0n) {
    let remainder = Number(n % 64n);
    result = BASE64_CHARS[remainder] + result;
    n = n / 64n;
  }
  return result;
}

/**
 * Calculates the Julian Date as per the MRA algorithm.
 */
const toJulianDate=(dateString)=> {
  const date = new Date(dateString);
  let year = date.getFullYear();
  let month = date.getMonth() + 1; // JavaScript months are 0-indexed
  let day = date.getDate();

  if (month <= 2) {
    year -= 1;
    month += 12;
  }

  const A = Math.floor(year / 100);
  const B = 2 - A + Math.floor(A / 4);

  const JD = Math.floor(365.25 * (year + 4716)) +
             Math.floor(30.6001 * (month + 1)) +
             day + B - 1524;
  return JD;
}

/**
 * Generates the final Invoice Number string.
 */
const generateInvoiceNumber=({ taxpayerId, terminalPosition, transactionDate, transactionCount })=> {
  const julianDate = toJulianDate(transactionDate);

  const b64Taxpayer = base10ToBase64(taxpayerId);
  const b64Position = base10ToBase64(terminalPosition);
  const b64Julian = base10ToBase64(julianDate);
  const b64Count = base10ToBase64(transactionCount);

  return `${b64Taxpayer}-${b64Position}-${b64Julian}-${b64Count}`;
}

const decrypt = (hash) => {

    // const decipher = crypto.createDecipheriv(algorithm, secretKey, Buffer.from(hash.iv, 'hex'));
    const decipher = crypto.createDecipheriv(algorithm, secretKey, iv);

    const decrypted = Buffer.concat([decipher.update(Buffer.from(hash, 'hex')), decipher.final()]);

    return decrypted.toString();
};

module.exports = {
    encrypt,
    decrypt,
    mra,
    generateInvoiceNumber
};